import { Action } from "../../models/Action";
import { clearStepSaleConfig, getStepSaleConfig } from "./saleStepConfigActions";

export interface StepSaleConfigState {
  loading: boolean;
  error: string | null;
  customOffers: StepSaleConfig[];
}

export interface StepSaleConfig {
  stepName: string;
  stepName_en?: string;
  stepId: string;
  stepDescription: string;
  stepDescription_en?: string;
  showInNavbar: boolean;
  showSimplifiedNavbar: boolean;
  highlightInNavbar: boolean;
  order: number;
  saleSteps: SaleStep[];
}

export enum ProductKinds {
  Pass = "pass",
  Event = "event",
  CalendarSale = "calendarSale",
  Color = "color",
  Shape = "shape",
  AssortGroup = "assortGroup",
}

export interface SaleStep {
  id: string;
  kind: ProductKinds;
  exerciseIds?: string;
  exerciseGroupIds?: string;
  exerciseName?: string;
  assortIds?: string;
  colorIds?: string;
  assortGroupIds?: string;
  shapeIds?: string;
  order: number;
  highlightBanner: boolean;
  bannerLabel: string;
  mainPrice: string;
  crossedPrice: string;
  priceLabel: string;
  highlightedFeature1: string;
  highlightedFeature2: string;
  highlightedFeature3: string;
  loginRequired: boolean;
  alwaysShowHoursToChooseInCalendarSale: boolean;
  alwaysShowTimeToEntryInCalendarSale: boolean;
  showOtherTicketsPool: boolean;
  passSaleVariant: boolean; // to dodałem pod krk aby nie było pre basketa tylko przyciski wybierz
  displayWithSelectableStartDate: boolean;
  allowToSignByPass: boolean;
  buttonCustomTitle: string;
  courtGridScheduleVariant?: boolean;
  weeklyGridScheduleVariant?: boolean;
  toursScheduleVariant: boolean;
}

const initialState: StepSaleConfigState = {
  loading: false,
  error: null,
  customOffers: [],
};

export default function stepSaleConfigReducer(state = initialState, action: Action<any>) {
  switch (action.type) {
    case getStepSaleConfig.pending.toString():
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getStepSaleConfig.fulfilled.toString():
      return {
        ...state,
        loading: false,
        customOffers: action.payload.list || state.customOffers,
      };
    case getStepSaleConfig.rejected.toString():
      return {
        ...state,
        loading: false,
        error: "Nie udało się załadować konfiguracji własnych podstron",
        customOffers: state.customOffers,
      };
    case clearStepSaleConfig.toString():
      return { ...initialState, customOffers: [] };
    default:
      return state;
  }
}
